import { alpha, Theme } from '@mui/material';
import { AvailabilityType } from 'generated/index';
import { GRAY_SECONDARY, WHITE } from 'constants/colors';

export type CalendarSlotType = AvailabilityType | 'DUTY';

type CalendarColorScheme = {
  // TODO: 1275 Remove after decision is made that we don't use colored borders in AppointmentPlanning.
  stripColor?: string;
  washColor: string;
};

export const getCalendarColorScheme = (
  type: CalendarSlotType,
  theme: Theme
): CalendarColorScheme => {
  switch (type) {
    case 'DUTY':
      return {
        washColor: WHITE
      };
    case 'AVAILABLE':
      return {
        washColor: alpha(theme.palette.success.main, 0.1)
      };
    case 'NOT_AVAILABLE':
      return {
        washColor: GRAY_SECONDARY
      };
    case 'POSSIBLE':
      return {
        washColor: alpha(theme.palette.warning.main, 0.1)
      };
    case 'UNSPECIFIED':
      return {
        washColor: alpha(theme.palette.primary.main, 0.1)
      };
    default:
      return {
        washColor: theme.palette.grey[100]
      };
  }
};
